/* The cart window (sections/cart-drawer.liquid). Cart (n) toggles it; "Add to cart" opens it (lagom:cart:open);
   it closes on ✕, Esc, a tap on the blurred page, or when the phone menu opens. − / + / Remove go through
   /cart/change.js with sections=cart-drawer, and the window's inside is replaced with the freshly rendered section,
   so prices and texts always come from Liquid. Lagom.cart.add (core.js) sends the same `sections`, so an add
   re-renders too. */
(function () {
  'use strict';
  var L = window.Lagom || {}, q = L.q || function (s, r) { return (r || document).querySelector(s); }, qa = L.qa || function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var C = L.config || {}, routes = C.routes || {};
  var panel = q('[data-cart-panel]'), scrim = q('[data-cart-scrim]'), toggles = qa('[data-cart-toggle], [data-cart-link]'), header = q('[data-header]');
  if (!panel) { return; }
  var SECTION = 'cart-drawer', timer = 0;
  function motionOff() { return L.motionOff ? L.motionOff() : false; }
  function isOpen() { return panel.classList.contains('is-open') && !panel.classList.contains('is-closing'); }
  function set(open) {
    window.clearTimeout(timer);
    if (open) {
      document.dispatchEvent(new CustomEvent('lagom:panel', { detail: 'cart' }));
      /* Phones: the window starts 12px under the navbar wherever it is (at the top of the page the bar sits lower,
         under the announcement). */
      var bar = header && q('.header__inner', header);
      panel.style.top = window.matchMedia('(max-width: 767px)').matches && bar ? Math.round(bar.getBoundingClientRect().bottom + 12) + 'px' : '';
      panel.classList.remove('is-closing'); panel.classList.add('is-open');
      if (scrim) { scrim.classList.add('is-on'); }
      document.documentElement.classList.add('is-cart-open'); L.lock.lock('cart');
      if (header) { header.classList.add('is-panel-open'); }
      panel.setAttribute('tabindex', '-1'); panel.focus({ preventScroll: true });
      tick();
    } else {
      if (scrim) { scrim.classList.remove('is-on'); }
      document.documentElement.classList.remove('is-cart-open'); L.lock.unlock('cart');
      if (header) { header.classList.remove('is-panel-open'); }
      if (panel.classList.contains('is-open') && !motionOff()) {
        panel.classList.add('is-closing');
        timer = window.setTimeout(function () { panel.classList.remove('is-open', 'is-closing'); }, 300);
      } else { panel.classList.remove('is-open', 'is-closing'); }
    }
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  /* Replace the inside with a rendered section (from /cart/change.js, /cart/add.js, or /?sections=). */
  function apply(html) {
    if (!html) { return; }
    var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('[data-cart-inner]'), cur = q('[data-cart-inner]', panel);
    if (!fresh || !cur) { return; }
    cur.innerHTML = fresh.innerHTML;
    var n = parseInt(fresh.getAttribute('data-cart-count-value'), 10);
    if (!isNaN(n) && L.cart && L.cart.setCount) { L.cart.setCount(n); }
    tick();
  }
  function refresh() {
    return fetch((routes.root || '/') + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (d) { apply(d[SECTION]); }).catch(function () {});
  }
  function change(line, qty) {
    panel.classList.add('is-busy');
    fetch((routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty, sections: SECTION }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.sections && cart.sections[SECTION]) { apply(cart.sections[SECTION]); } else { return refresh(); } })
      .catch(function () { return refresh(); })
      .then(function () { panel.classList.remove('is-busy'); });
  }
  /* "We have reserved your order for 10 minutes": the deadline is kept in sessionStorage, so it survives re-renders and
     page loads in the tab; every add restarts it. It is shown while the cart has items and time is left, counts down
     once a second while the window is open (one text write a second, only when the digits change), and is dropped
     when the cart is empty; a cart with items but no running reservation gets a fresh one when the window opens. */
  var RESERVE_MS = 10 * 60 * 1000, RKEY = 'lagom-cart-reserved', rTimer = 0, rLast = '';
  function store(get, val) { try { if (get) { return window.sessionStorage.getItem(RKEY); } if (val === null) { window.sessionStorage.removeItem(RKEY); } else { window.sessionStorage.setItem(RKEY, String(val)); } } catch (e) {} return null; }
  function count() { var inner = q('[data-cart-inner]', panel); return inner ? parseInt(inner.getAttribute('data-cart-count-value'), 10) || 0 : 0; }
  function reserve() { store(false, Date.now() + RESERVE_MS); rLast = ''; tick(); }
  function tick() {
    window.clearTimeout(rTimer);
    var box = q('[data-cart-reserved]', panel), out = box && q('[data-cart-timer]', box);
    if (!box) { return; }
    var until = parseInt(store(true), 10) || 0, left = until - Date.now();
    if (count() > 0 && left <= 0) { until = Date.now() + RESERVE_MS; store(false, until); left = RESERVE_MS; }   /* items but no (or a spent) reservation: a fresh 10 minutes */
    if (count() === 0) { store(false, null); left = 0; }
    if (left <= 0) { if (!box.hidden) { box.hidden = true; } rLast = ''; return; }
    var sec = Math.ceil(left / 1000), txt = Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2);
    if (txt !== rLast) { out.textContent = txt; rLast = txt; }
    if (box.hidden) { box.hidden = false; }
    if (panel.classList.contains('is-open')) { rTimer = window.setTimeout(tick, 1000 - (left % 1000) + 20); }
  }
  toggles.forEach(function (t) {
    t.setAttribute('aria-controls', 'cart-panel'); t.setAttribute('aria-expanded', 'false');
    t.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); set(!isOpen()); });
  });
  panel.addEventListener('click', function (e) {
    e.stopPropagation();
    var b = e.target.closest('[data-qty]'), r = e.target.closest('[data-remove]'), li = e.target.closest('[data-line]');
    if (b && li) { var cur = parseInt((q('[aria-live]', li) || {}).textContent, 10) || 0; change(parseInt(li.getAttribute('data-line'), 10), Math.max(0, cur + parseInt(b.getAttribute('data-qty'), 10))); return; }
    if (r && li) { change(parseInt(li.getAttribute('data-line'), 10), 0); return; }
    if (e.target.closest('[data-cart-close]')) { set(false); }
  });
  if (scrim) { scrim.addEventListener('click', function () { set(false); }); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { set(false); if (toggles[0]) { toggles[0].focus(); } } });
  document.addEventListener('lagom:panel', function (e) { if (e.detail !== 'cart' && isOpen()) { set(false); } });
  /* After an add (core.js): a rendered section when the add sent one, else a refetch; then open. */
  document.addEventListener('lagom:cart', function (e) {
    var cart = e.detail || {};
    if (cart.silent) { if (cart.sections && cart.sections[SECTION]) { apply(cart.sections[SECTION]); } return; }   // checkout: straight on, no window
    reserve();
    (cart.sections && cart.sections[SECTION] ? Promise.resolve(apply(cart.sections[SECTION])) : refresh()).then(function () { reserve(); set(true); });
  });
  document.addEventListener('lagom:cart:open', function () { set(true); });
  /* The toast's "View cart" link opens the window instead of leaving the page. */
  qa('[data-toast-link]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); set(true); }); });
  /* Back-forward cache: the cart may have changed on the checkout page. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh(); } });
  tick();
})();
